var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"q-app"}},[_c('transition-group',{attrs:{"appear":"","leave-active-class":"animated fadeOut"}},[(_vm.fullLoading)?_c('div',{key:"div2",staticClass:"loaderOverlay",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('img',{staticStyle:{"width":"300px","height":"150px"},attrs:{"src":"/statics/Oatas Hero Logo-03.svg","alt":"Oatas Hero Logo"}})]):_vm._e()]),_c('popout'),_c('q-layout',{attrs:{"view":"hHh lpR fFf"}},[(!_vm.$route.meta.fullscreen)?_c('app-bar'):_vm._e(),_c('q-page-container',[_c('q-scroll-area',{style:(`height: calc(100vh - ${
          _vm.$route.meta.fullscreen != true ? '60px' : '0px'
        })`),attrs:{"thumb-style":{
          background: '#162c479c',
          opacity: 1,
          width: '8px',
          height: '8px',
          borderRadius: '20px',
        }}},[_c('router-view',{class:{
            'q-pa-sm':
              !_vm.$route.meta.fullscreen &&
              this.$q.screen.lt.sm &&
              _vm.routeNamesWithNoPadding.includes(_vm.$route.name),
            'q-pa-md':
              !_vm.$route.meta.fullscreen &&
              this.$q.screen.gt.sm &&
              _vm.routeNamesWithNoPadding.includes(_vm.$route.name),
          }})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }